import { useBusEmitterListener } from "../bridge";
import { useDocumentStore } from "../store/document";

const issueCreatedEvent = Symbol("bridge:issueCreated");

export const {
  emitter: issueCreated,
  listener: onIssueCreated,
} = useBusEmitterListener<string>(issueCreatedEvent);

export async function create(jsonValue: string) {
  console.log(jsonValue);
  const store = useDocumentStore();
  // const { mutate } = useCreateSpecIssue("4nmsyf");
  // mutate({ title: jsonValue });

  if (!store.shortcut) return;

  // const issue = await createSpecIssue(store.shortcut, jsonValue);
  // issueCreated(issue.code);
  // createIssue(jsonValue);
  // return issue.code;
  return undefined;
}

const openCardLinkEvent = Symbol("bridge:openCardLinkEvent");

const {
  emitter: requestOpenCardLinkFn,
  listener: onRequestOpenCardLinkFn,
} = useBusEmitterListener<{ url: string; objectId: string }>(openCardLinkEvent);

export function openCardLinkTriggered(url: string, objectId: string) {
  requestOpenCardLinkFn({ url, objectId });
}

export const onRequestOpenCardLink = onRequestOpenCardLinkFn;
